export default "__VITE_ASSET__7d0510ae__";